/**
 * The token contract.
 *
 * Every piece in this package reads these custom properties and nothing
 * else, so a host makes Lissen identity look at home by setting them once
 * on an ancestor — the checkout from its partner appearance, Link in Bio
 * from its page theme. The fallbacks are neutral, so a host that sets
 * nothing still gets something legible.
 */
export const tokens = {
  /** Body text on the host's surface. */
  text: "var(--lid-text, #1f2937)",
  /** Secondary text: labels, hints. */
  muted: "var(--lid-muted, #6b7280)",
  /** The fill of a field. */
  surface: "var(--lid-surface, #ffffff)",
  border: "var(--lid-border, rgba(31, 41, 55, 0.16))",
  borderWidth: "var(--lid-border-width, 1px)",
  /** The host's action colour: focus, selection. */
  accent: "var(--lid-accent, #334155)",
  /** The box-shadow a focused field wears. */
  focusRing: "var(--lid-focus-ring, 0 0 0 3px rgba(51, 65, 85, 0.25))",
  danger: "var(--lid-danger, #b91c1c)",
  /** An accepted code. */
  success: "var(--lid-success, #15803d)",
  radius: "var(--lid-radius, 8px)",
  radiusSmall: "var(--lid-radius-sm, 5px)",
  controlHeight: "var(--lid-control-height, 44px)",
  /** One step of spacing; gaps are multiples of it. */
  space: "var(--lid-space, 8px)",
  fontSizeSmall: "var(--lid-font-size-small, 0.875em)",
} as const;

/** The names a host sets, for the host that wants to enumerate them. */
export const TOKEN_NAMES = [
  "--lid-text",
  "--lid-muted",
  "--lid-surface",
  "--lid-border",
  "--lid-border-width",
  "--lid-accent",
  "--lid-focus-ring",
  "--lid-danger",
  "--lid-success",
  "--lid-radius",
  "--lid-radius-sm",
  "--lid-control-height",
  "--lid-space",
  "--lid-font-size-small",
] as const;

/**
 * The app icon's own dress, for what is Lissen's on a host's page: the chip
 * of a buyer Lissen knows. The icon's dark vertical ground and its
 * coral-to-orange border, as two backgrounds on one box — the ground clipped
 * to the padding box, the border gradient filling the border box behind it.
 */
export const lissenDress = {
  background:
    "linear-gradient(180deg, #033a46 0%, #033a46 34%, #222233 60%, #1a1a2e 100%) padding-box, linear-gradient(90deg, #da5263, #f29951) border-box",
  border: "2px solid transparent",
  color: "#ffffff",
} as const;
